import { render, staticRenderFns } from "./_author_review.vue?vue&type=template&id=60fd0eda"
import script from "./_author_review.vue?vue&type=script&lang=js"
export * from "./_author_review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports